<template>
  <entity-select-dialog
    ref="entitySelectDialog"
    :search="search"
    :items="items"
    :loading="loading"
  >
    <template v-slot:listItem="props">
      <SupplierListItem
        :item="props.item"
        :showActions="false"
        :rowClickEnabled="true"
      />
    </template>
  </entity-select-dialog>
</template>

<script>
import EntitySelectDialog from '@/components/entity-crud/EntitySelectDialog';
import SupplierListItem from '@/views/suppliers/SupplierListItem';
import SupplierService from '@/services/SupplierService';

export default {
  name: 'SupplierSelectDialog',
  components: { SupplierListItem, EntitySelectDialog },

  data: () => ({
    items: [],
    loading: false,
  }),

  methods: {
    selectedEntity(supplier) {
      this.$emit('selected', supplier);
      this.close();
    },

    show() {
      this.$refs.entitySelectDialog.show();
    },

    close() {
      this.$refs.entitySelectDialog.close();
    },

    mapToItem(supplier) {
      return {
        supplier,
        rowClick: () => {
          this.selectedEntity(supplier);
        },
      };
    },
    search(searchTerm) {
      if (!searchTerm) {
        searchTerm = null;
      }

      this.items = [];
      this.loading = true;

      SupplierService.findByName(searchTerm)
        .then((result) => {
          this.items = result.data.map((item) => this.mapToItem(item));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
